import { ApiResponse, PrefectureDto } from "@/types";
import api from "./api";

export const prefectureService = {
  getPrefectures: async (): Promise<ApiResponse<PrefectureDto>> => {
    const response = await api.get('/prefectures/simple');
    return response.data;
  },
};
